import { type DietaryRestriction } from '@sg/graphql-schema';

import { type DietaryPreferencesTypes } from '../setup';

// ─────────────────────────────────────────────────────────────────────────────

export function checkIfHasUnsavedPreferences(
  preferences: DietaryPreferencesTypes,
  pendingPreferences: DietaryPreferencesTypes,
) {
  const preferenceEntries = Object.entries(preferences);
  const checkIfValuesAreDifferent = checkIfValuesAreDifferentFactory(pendingPreferences); // prettier-ignore

  return preferenceEntries.some(checkIfValuesAreDifferent);
}

// ─────────────────────────────────────────────────────────────────────────────

function checkIfValuesAreDifferentFactory(
  pendingPreferences: DietaryPreferencesTypes,
) {
  return function (preferenceEntry: PreferenceEntry) {
    const [kind, value] = preferenceEntry;
    const castedKind = kind as DietaryRestriction;

    return pendingPreferences[castedKind] !== value;
  };
}

// ─── Types ───────────────────────────────────────────────────────────────────

type PreferenceEntry = [string, boolean];
